import { useDispatch, useSelector } from 'react-redux';
import ChatNow from 'components/Layout/ChatNow';
import { setIsFeedback } from 'store/slices';
import { getDataFromLocalStorage } from 'utils/helpers';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import Feedback from './Feedback';
import './Layout.scss';
// import EmailNotificationPopup from 'components/Layout/EmailNotificationPopup';

const Layout = ({ children, id }) => {
  const dispatch = useDispatch();
  const { isFeedback, isCollapseSidebar } = useSelector((state) => ({
    isFeedback: state.global.isFeedback,
    isCollapseSidebar: state.global.isCollapseSidebar,
  }));
  const access = {
    isFeedback: !['0', '1', '6'].includes(getDataFromLocalStorage('user_type')),
    isChat:
      !['0', '1', '6'].includes(getDataFromLocalStorage('user_type')) &&
      !window.location.pathname.includes('network/chat'),
    // isEmailNotificationPopup: ['6'].includes(getDataFromLocalStorage('user_type'))
  };
  return (
    <div id="Layout-container">
      <Sidebar />
      <main
        className={`main-body-content ${isCollapseSidebar ? 'expand-all-body' : ''
          }`}
      >
        <Navbar />
        <div id={id} className="body-padding body-height iferp-scroll bg-f4fc">
          {children}
        </div>
      </main>
      {isFeedback && <Feedback />}
      {access?.isFeedback && !isFeedback && (
        <div
          className="btn-feedback shadow"
          onClick={() => {
            dispatch(setIsFeedback(true));
          }}
        >
          <i className="bi bi-chat-square-dots me-2" />
          Feedback
        </div>
      )}
      {access?.isChat && <ChatNow />}
      {/* {access?.isEmailNotificationPopup && <EmailNotificationPopup />} */}
    </div>
  );
};
export default Layout;
